import { Injectable } from '@angular/core';
@Injectable()
export class GlobalStorage {
    constructor() { }

    get_access_token() {
        return sessionStorage.getItem('access_token');
    }
    get_expires_in() {
        return sessionStorage.getItem('expires_in');
    }
}